<nav class="d-flex gap-3 align-items-center flex-wrap">
  @if (title()) {
    <h2 class="h6 mb-0">{{ title() }}</h2>
  }
  <ul class="follow-button-list d-flex gap-2 social-channels__list">
    @for (channel of channels(); track channel.id) {
      <li class="follow-button-list__item">
        <a [href]="channel.url" target="_blank" class="button button-icon button--light">
          <span class="sr-only">{{ channel.title }}</span>

          @if (channel.icon || (channel.url | socialIcon); as icon) {
            <fstr-icon class="fs-body-md" [anchor]="icon"></fstr-icon>
          }
        </a>
      </li>
    }
  </ul>
</nav>
